import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/Home";
import Shows from "@/components/Shows";
import OnDemand from "@/components/OnDemand";
import Latest from "@/components/Latest";
import About from "@/components/About";
import OffStage from "@/components/OffStage";
import Other from "@/components/Other";

Vue.use(Router);

const router = new Router({
    // mode: 'history',
    routes: [
        {
            path: "/",
            name: "Home",
			component: Home,
			meta: {
				title: 'Ross Noble'
			}
        },
        {
            path: "/shows",
            name: "Shows",
            component: Shows,
			meta: {
				title: 'Shows'
			}
        },
        {
            path: "/ondemand",
            name: "OnDemand",
            component: OnDemand,
			meta: {
				title: 'On Demand'
			}
        },
        {
            path: "/latest",
            name: "Latest",
            component: Latest,
			meta: {
				title: 'Latest'
			}
        },
        {
            path: "/about",
            name: "About",
            component: About,
			meta: {
				title: 'About'
			}
        },
        {
            path: "/other",
            name: "Other",
            component: Other,
			meta: {
				title: 'Other'
			}
        },
        {
            path: "/offstage",
            name: "OffStage",
            component: OffStage,
			meta: {
				title: 'Off Stage'
			}
        }
	],
    scrollBehavior(to, from, savedPosition) {
        setTimeout(() => {
            return { x: 0, y: 0 };
        }, 100);
    }
});

router.afterEach(to => {
	document.title = to.meta.title;
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js